"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
require("./index.scss");
const NoSongwritersMessage = () => (react_1.default.createElement("div", { className: 'no-songwriters-message' },
    react_1.default.createElement("p", null,
        react_1.default.createElement("strong", null, "You have nothing here")),
    react_1.default.createElement("p", null, "The MLC Songwriter Hub is a central place for songwriters to verify information in an effort to locate all songs they may have claims on and manage their catalog."),
    react_1.default.createElement(Button_1.Button, { mainColor: true, typeLink: true, type: 'primary', linkTo: navigation_1.default.registrationSongwriter.root() }, "Join Songwriter Hub")));
exports.default = NoSongwritersMessage;
